
  <form @submit.prevent="save" ref="form">
    <b-loading :active="isLoading"></b-loading>
    <div class="modal-card">
      <header class="modal-card-head">
        <form ref="routeMapPdf" method="post" target="_blank" :action="urlToRouteMapPdf">
          <input type="hidden" name="map" :value="mapImage" />
          <input type="hidden" name="routeDistances" :value="JSON.stringify(distances)" />
          <button
              class="button is-small is-outlined is-pdf-link"
              :class="{ 'is-loading': isSubmitting }"
              type="button"
              @click="submitMapPdfForm"
              :disabled="isSubmitting || isMapCentering || isLoading"
              v-if="isAdmin || canNonAdminSeeTopButtons"
          >
            <i class="mdi">picture_as_pdf</i> PDF
          </button>
        </form>
        <form
            ref="routeMapDoc"
            method="post"
            target="_blank"
            :action="urlToRouteMapDoc"
            v-if="!isLite && (isAdmin || canNonAdminSeeTopButtons)"
        >
          <input type="hidden" name="map" :value="mapImage" />
          <input type="hidden" name="routeDistances" :value="JSON.stringify(distances)" />
          <button
              class="button is-small is-outlined is-doc-link"
              :class="{ 'is-loading': isSubmitting }"
              type="button"
              @click="submitMapDocForm"
              :disabled="isSubmitting || isMapCentering || isLoading"
          >
            <i class="mdi">description</i> DOC
          </button>
        </form>
        <a
            :href="urlToRouteProductionPdf"
            target="_blank"
            class="button is-small is-outlined is-pdf-link"
            v-if="isRouteProductionPdfAvailable"
        >
          <i class="mdi">picture_as_pdf</i> Produkcja PDF
        </a>
        <a
            :href="urlToRouteProductionDoc"
            target="_blank"
            class="button is-small is-outlined is-doc-link"
            v-if="isRouteProductionDocAvailable"
        >
          <i class="mdi">description</i> Produkcja DOC
        </a>
        <p class="modal-card-title">
          Szczegóły trasy:
          <b>{{ currentRoute.name }}</b>
        </p>
        <button
            type="button"
            class="delete"
            aria-label="close"
            @click="$parent.$emit('close')"
        ></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <h2>{{ isEditModeEnabled ? 'Edycja' : 'Szczegóły' }} trasy</h2>
            <div class="group">
              <div class="field is-horizontal">
                <div class="field-label">Nazwa trasy:</div>
                <editable
                    :isEditMode="isEditModeEnabled"
                    :value="currentRoute.name"
                    required
                    placeholder="Nazwa trasy"
                    type="text"
                    @input="currentRoute.name = $event"
                />
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Dodał:</div>
                <div class="field field-body is-grouped">
                  <span>{{ currentRoute.creator ? currentRoute.creator.username : '-' }}</span>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Kolor:</div>
                <div class="field-body">
									<span class="route-color" v-if="currentRoute.color">
										<span
                        :style="`background-color: ${getColorByName(currentRoute.color).hex};`"
                        class="route-color__preview"
                    ></span>
										<span class="route-color__name">{{
                        getColorByName(currentRoute.color).name
                      }}</span>
									</span>
                  <i class="no-route-color" v-else>-- brak --</i>
                  <button
                      type="button"
                      class="button is-small change-color"
                      @click.prevent="isColorPickerActive = true"
                      v-if="isEditModeEnabled"
                  >
                    Zmień
                  </button>
                </div>
              </div>
              <hr />
              <div class="field is-horizontal">
                <div class="field-label">Status:</div>
                <div class="field-body">
                  <b-dropdown :disabled="!canModifyRoute">
                    <button
                        class="button is-info is-small"
                        slot="trigger"
                        @click.prevent
                        type="button"
                    >
                      <span>{{ currentRoute.status | formatStatus }}</span>
                      <i class="mdi">arrow_drop_down</i>
                    </button>
                    <b-dropdown-item
                        @click="changeStatus('planned')"
                        v-if="
												currentRoute.status === 'trashed' ||
												currentRoute.status === 'complaint' ||
												currentRoute.status === 'sent' ||
												currentRoute.status === 'archived' ||
												currentRoute.status === 'inProduction'
											"
                    >
                      Zmień na
                      <b>"Zaplanowane"</b>
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="changeStatus('inProduction')"
                        v-if="
												isInProductionStatusEnabled &&
												(currentRoute.status === 'trashed' ||
													currentRoute.status === 'complaint' ||
													currentRoute.status === 'planned' ||
													currentRoute.status === 'archived')
											"
                    >
                      Zmień na
                      <b>"Produkcja"</b>
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="changeStatus('sent')"
                        v-if="
												currentRoute.status === 'trashed' ||
												currentRoute.status === 'complaint' ||
												currentRoute.status === 'planned' ||
												currentRoute.status === 'archived' ||
												currentRoute.status === 'inProduction'
											"
                    >
                      Zmień na
                      <b>"Wysłane"</b>
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="changeStatus('trashed')"
                        v-if="
												currentRoute.status === 'complaint' ||
												currentRoute.status === 'sent' ||
												currentRoute.status === 'planned' ||
												currentRoute.status === 'archived' ||
												currentRoute.status === 'inProduction'
											"
                    >
                      Przenieś do <b>"Kosz"</b>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <div class="field is-horizontal" v-if="isAdmin || agentsCanSeeRouteTotals">
                <div class="field-label">Suma zamówień:</div>
                <div class="field-body total-prices">
                  <p v-if="routeTotalPrice.PLN">{{ routeTotalPrice.PLN }} zł</p>
                  <p v-if="routeTotalPrice.CZK">{{ routeTotalPrice.CZK }} Kč</p>
                  <p v-if="routeTotalPrice.EUR">{{ routeTotalPrice.EUR }} EUR</p>
                  <p v-if="routeTotalPrice.HUF">{{ routeTotalPrice.HUF }} HUF</p>
                  <p v-if="routeTotalPrice.RON">{{ routeTotalPrice.RON }} RON</p>
                  <p
                      v-if="
											!routeTotalPrice.PLN &&
											!routeTotalPrice.CZK &&
											!routeTotalPrice.EUR &&
											!routeTotalPrice.HUF &&
											!routeTotalPrice.RON
										"
                  >
                    -
                  </p>
                </div>
              </div>
              <div class="field is-horizontal" v-if="isAdmin || agentsCanSeeRouteTotals">
                <div class="field-label">Suma przelewem:</div>
                <div class="field-body total-prices">
                  <p v-if="routeTotalPriceByTransfer.PLN">{{ routeTotalPriceByTransfer.PLN }} zł</p>
                  <p v-if="routeTotalPriceByTransfer.CZK">{{ routeTotalPriceByTransfer.CZK }} Kč</p>
                  <p v-if="routeTotalPriceByTransfer.EUR">
                    {{ routeTotalPriceByTransfer.EUR }} EUR
                  </p>
                  <p v-if="routeTotalPriceByTransfer.HUF">
                    {{ routeTotalPriceByTransfer.HUF }} HUF
                  </p>
                  <p v-if="routeTotalPriceByTransfer.RON">
                    {{ routeTotalPriceByTransfer.RON }} RON
                  </p>
                  <p
                      v-if="
											!routeTotalPriceByTransfer.PLN &&
											!routeTotalPriceByTransfer.CZK &&
											!routeTotalPriceByTransfer.EUR &&
											!routeTotalPriceByTransfer.HUF &&
											!routeTotalPriceByTransfer.RON
										"
                  >
                    -
                  </p>
                </div>
              </div>
              <div class="field is-horizontal" v-if="isAdmin || agentsCanSeeRouteTotals">
                <div class="field-label">Suma gotówką:</div>
                <div class="field-body total-prices">
                  <p v-if="routeTotalPriceByCash.PLN">{{ routeTotalPriceByCash.PLN }} zł</p>
                  <p v-if="routeTotalPriceByCash.CZK">{{ routeTotalPriceByCash.CZK }} Kč</p>
                  <p v-if="routeTotalPriceByCash.EUR">{{ routeTotalPriceByCash.EUR }} EUR</p>
                  <p v-if="routeTotalPriceByCash.HUF">{{ routeTotalPriceByCash.HUF }} HUF</p>
                  <p v-if="routeTotalPriceByCash.RON">{{ routeTotalPriceByCash.RON }} RON</p>
                  <p
                      v-if="
											!routeTotalPriceByCash.PLN &&
											!routeTotalPriceByCash.CZK &&
											!routeTotalPriceByCash.EUR &&
											!routeTotalPriceByCash.HUF &&
											!routeTotalPriceByCash.RON
										"
                  >
                    -
                  </p>
                </div>
              </div>
              <!-- <div class="field is-horizontal">
                <div class="field-label">Suma zamówień PLN:</div>
                <div class="field-body">
                  <p>{{ routeTotalPrice.PLN }} zł</p>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label">Suma zamówień CZK:</div>
                <div class="field-body">
                  <p>{{ routeTotalPrice.CZK }} Kč</p>
                </div>
              </div>-->
              <div class="field is-horizontal" v-if="agentsCanEditEverything">
                <div class="field-label">Długość trasy:</div>
                <div class="field-body">{{ routeTotalDistance }}</div>
              </div>
            </div>

            <h2 v-if="isRouteDocumentAttachmentEnabled">Załącznik</h2>
            <div v-if="isRouteDocumentAttachmentEnabled" class="route-route-attachment">
              <div v-if="!currentRoute.id" class="route-route-attachment__empty">
                <p class="picture__empty">Załącznik będzie można dodać po zapisaniu trasy.</p>
              </div>
              <div v-else class="route-route-attachment__body">
                <div v-if="isRouteAttachmentDeleting" class="route-attachment__deleting">
                  <b-loading :active="true" :is-full-page="false"></b-loading>
                </div>
                <template v-else>
                  <div class="attachments-list">
                    <div v-if="routeAttachmentMedia" class="attachment-item">
                      <div class="attachment-item__layout">
                        <div class="attachment-item__preview">
                          <div
                              v-if="isRouteAttachmentUploading"
                              class="attachment-item__preview-loading"
                          >
                            <b-loading :active="true" :is-full-page="false"></b-loading>
                          </div>
                          <a
                              v-else
                              :href="routeAttachmentDocUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                              class="route-doc-badge-link"
                              :title="routeAttachmentLinkTitle"
                              :aria-label="'Pobierz: ' + routeAttachmentLinkCaption"
                          >
                            <div
                                class="route-doc-badge route-doc-badge--compact"
                                :class="'route-doc-badge--' + routeAttachmentDocBadge.kind"
                            >
																<span class="route-doc-badge__ext-chip">{{
                                    routeAttachmentDocBadge.extLabel
                                  }}</span>
                            </div>
                          </a>
                        </div>
                        <div class="attachment-item__main">
                          <div class="attachment-item__header-row">
                            <div class="attachment-item__title-block">
                              <a
                                  class="route-attachment-filename"
                                  :href="routeAttachmentDocUrl"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  :title="routeAttachmentLinkTitle"
                                  :aria-label="'Pobierz: ' + routeAttachmentLinkCaption"
                              >
																	<span class="route-attachment-filename__text">{{
                                      routeAttachmentLinkCaption
                                    }}</span>
                                <i class="mdi route-attachment-filename__ext-icon">open_in_new</i>
                              </a>
                              <p v-if="routeAttachmentMetaLine" class="attachment-item__meta">
                                {{ routeAttachmentMetaLine }}
                              </p>
                            </div>
                            <div
                                v-if="canEditRouteAttachment"
                                class="attachment-item__header-actions"
                            >
                              <b-upload
                                  v-model="routeAttachmentFile"
                                  :accept="routeDocumentUploadAccept"
                                  @input="onRouteAttachmentFileInput"
                                  :disabled="isRouteAttachmentUploading"
                                  class="route-attachment-change-upload"
                              >
																	<span
                                      class="button is-info is-small"
                                      :class="{
																			'is-loading': isRouteAttachmentUploading,
																			'is-disabled': isRouteAttachmentUploading
																		}"
                                      role="button"
                                      tabindex="0"
                                  >
																		<i class="mdi">edit</i>
																		<span>Zmień</span>
																	</span>
                              </b-upload>
                              <button
                                  type="button"
                                  class="button is-small is-light route-attachment-desc-toggle"
                                  @click="onRouteAttachmentDescriptionToggle"
                              >
                                <span>{{ routeAttachmentDescriptionPanelToggleLabel }}</span>
                              </button>
                              <button
                                  type="button"
                                  class="button is-danger is-light is-small"
                                  :disabled="isRouteAttachmentUploading"
                                  @click="deleteRouteAttachment"
                              >
                                <i class="mdi">delete</i>
                                <span>Usuń</span>
                              </button>
                            </div>
                          </div>
                          <div
                              v-if="canEditRouteAttachment && isRouteAttachmentDescriptionOpen"
                              class="attachment-item__description-panel"
                          >
                            <b-field class="attachment-item__desc">
                              <b-input
                                  v-model="routeAttachmentDescriptionDraft"
                                  type="textarea"
                                  rows="4"
                                  placeholder="Opcjonalny opis"
                                  :disabled="
																		isRouteAttachmentUploading ||
																		isSavingRouteAttachmentDescription ||
																		isClearingRouteAttachmentDescription
																	"
                              />
                            </b-field>
                            <div class="attachment-item__save-row">
                              <button
                                  type="button"
                                  class="button is-info is-small"
                                  :class="{ 'is-loading': isSavingRouteAttachmentDescription }"
                                  :disabled="
																		isRouteAttachmentUploading ||
																		isSavingRouteAttachmentDescription ||
																		isClearingRouteAttachmentDescription ||
																		!isRouteAttachmentDescriptionDirty
																	"
                                  @click="persistRouteAttachmentDescription"
                              >
                                <i class="mdi">save</i>
                                <span>Zapisz</span>
                              </button>
                              <button
                                  type="button"
                                  class="button is-danger is-light is-small"
                                  :class="{ 'is-loading': isClearingRouteAttachmentDescription }"
                                  :disabled="
																		isRouteAttachmentUploading ||
																		isSavingRouteAttachmentDescription ||
																		isClearingRouteAttachmentDescription ||
																		!canClearRouteAttachmentDescription
																	"
                                  @click="clearRouteAttachmentDescription"
                              >
                                <i class="mdi">delete</i>
                                <span>Usuń opis</span>
                              </button>
                            </div>
                          </div>
                          <p
                              v-else-if="!canEditRouteAttachment && routeAttachmentDescriptionRead"
                              class="attachment-item__desc-read"
                          >
                            {{ routeAttachmentDescriptionRead }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                        v-if="canEditRouteAttachment && !routeAttachmentMedia"
                        class="attachment-upload-tile"
                    >
                      <b-upload
                          v-model="routeAttachmentFile"
                          :accept="routeDocumentUploadAccept"
                          @input="onRouteAttachmentFileInput"
                          :loading="isRouteAttachmentUploading"
                          :disabled="isRouteAttachmentDeleting || isRouteAttachmentUploading"
                          class="attachment-upload-tile__control"
                      >
                        <div
                            class="attachment-upload-tile__inner"
                            :class="{ 'is-loading': isRouteAttachmentUploading }"
                        >
                          <div
                              v-if="isRouteAttachmentUploading"
                              class="attachment-upload-tile__spinner"
                          >
                            <b-loading :active="true" :is-full-page="false"></b-loading>
                          </div>
                          <template v-else>
                            <span class="attachment-upload-tile__text">+ Dodaj</span>
                            <small>(0/1)</small>
                            <small class="attachment-upload-tile__hint attachment-upload-tile__hint-line">{{
                                routeDocumentUploadHintFormatsLine
                              }}</small>
                            <small class="attachment-upload-tile__hint attachment-upload-tile__hint-line">{{
                                routeDocumentUploadHintMaxSizeLine
                              }}</small>
                          </template>
                        </div>
                      </b-upload>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <h2 v-if="agentsCanEditEverything">Wizualizacja trasy</h2>
            <div class="group" v-if="agentsCanEditEverything">
              <div class="map-controls">
                <b-switch v-model="areMarkersVisible">pokaż markery</b-switch>
                <b-switch v-model="areMarkersLabelsVisible" :disabled="!areMarkersVisible"
                >pokaż nr. zamówień</b-switch
                >
              </div>
              <div id="route-map" :class="{ pdf: isSubmitting, 'mapboxgl-map': true }"></div>
            </div>
          </div>
          <div class="column is-two-thirds" v-if="!isEditModeEnabled">
            <h2>Zamówienia</h2>
            <div class="group orders">
              <div class="change-start-point-wrapper" v-if="canChangeStartPoint">
                <div class="start-point-actions" v-if="!isChangeStartPointModeEnabled">
                  <button
                      type="button"
                      class="button is-info"
                      @click="isChangeStartPointModeEnabled = true"
                  >
                    {{ startPointActionLabel }}
                  </button>
                  <button
                      type="button"
                      class="button is-warning reverse-order-btn"
                      @click="reverseOrder"
                  >
                    <i class="mdi">rotate_left</i> Odwróć kolejność
                  </button>
                </div>
                <p class="help is-info start-point-help" v-if="!isChangeStartPointModeEnabled && !currentRoute.startPoint">
                  Domyślnie startem jest pierwszy adres na liście.
                </p>
                <div v-if="isChangeStartPointModeEnabled">
                  <b-field label="Adres punktu startowego" grouped></b-field>
                  <b-field grouped>
                    <b-autocomplete
                        :data="filteredDataArray"
                        placeholder="12-123 Kraków, Ślężna 12"
                        icon="magnify"
                        clearable
                        expanded
                        :loading="isStartPointFetching"
                        field="display_label"
                        @input="getStartPointLocation"
                        @select="(option) => (startPoint = option)"
                    >
                      <template #empty>Brak pasujących wyników.</template>
                    </b-autocomplete>
                    <button
                        type="button"
                        class="button is-danger cancel-start-point"
                        @click="isChangeStartPointModeEnabled = false"
                    >
                      Anuluj
                    </button>
                    <button
                        type="button"
                        class="button is-success save-start-point"
                        @click="saveStartPoint"
                    >
                      Zapisz
                    </button>
                  </b-field>
                </div>
              </div>

              <hr v-if="canChangeStartPoint" />

              <div class="order-item order-item--start" v-if="currentRoute.startPoint">
                <span>Punkt startowy</span>
                <span
                ><i class="mdi">{{ getMarkerIconName(0, 0, false) }}</i>
									{{ JSON.parse(currentRoute.startPoint).display_name }}</span
                >
                <div class="action">
                  <button type="button" class="button is-small is-danger" @click="deleteStartPoint">
                    Usuń punkt startowy
                  </button>
                </div>
              </div>

              <draggable
                  v-if="routeOrders.length"
                  v-model="routeOrders"
                  tag="ul"
                  v-bind="dragOptions"
                  class="orders-list"
                  :move="onMoveDraggable"
                  :disabled="!canModifyRoute"
              >
                <transition-group type="transition">
                  <li
                      v-for="(order, index) in routeOrders"
                      :key="order.id"
                      class="order-item"
                      :disabled="!order.lat || !order.lon"
                  >
                    <!-- <svg
                      class="flag"
                      v-if="order.currency === 'PLN'"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 30 20"
                    >
                      <rect x="0" y="0" width="100%" height="50%" fill="#fff" />
                      <rect x="0" y="50%" width="100%" height="50%" fill="#d7141a" />
                    </svg>
                    <svg
                      class="flag"
                      v-if="order.currency === 'CZK'"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 30 20"
                    >
                      <rect x="0" y="0" width="100%" height="50%" fill="#fff" />
                      <rect x="0" y="50%" width="100%" height="50%" fill="#d7141a" />
                      <path d="M 15,10 0,0 V 20 z" fill="#11457e" />
                    </svg>-->
                    <b class="order-no">{{ index + 1 }}</b>
                    <div
                        class="montage"
                        v-if="order.type === 'order' && (canNonAdminSeeRouteAsAdmin || user.id === getOrderCreatorId(order))"
                    >
                      <p class="price">
                        Cena {{ order.price }} {{ getCurrencyLabel(order.currency) }}
                      </p>
                      <p class="montage-date">
                        <i class="mdi">build</i>
                        <flat-pickr
                            placeholder="godz."
                            class="time-input"
                            :config="timePickerConfig"
                            :value="normalizeMontageTime(order.montageTime)"
                            :disabled="isLoading"
                            @on-open="setChangingTimeModeActive"
                            @on-close="(selectedDates) => changeMontageTime(order, selectedDates)"
                        />
                        <flat-pickr
                            placeholder="data"
                            class="date-input"
                            :config="datePickerConfig"
                            :value="normalizeMontageDate(order.montageDate)"
                            :disabled="isLoading || isChangingTimeModeActive"
                            @on-close="(selectedDates) => changeMontageDate(order, selectedDates)"
                        />
                        <!-- <button @click.prevent="clearMontageDateTime(order)">clear</button> -->
                      </p>
                      <div v-if="!isLite">
                        <b-switch
                            :value="order.isApproved"
                            :disabled="isLoading || isChangingTimeModeActive"
                            @input="(isApproved) => changeIsApprovedStatus(order, isApproved)"
                            type="is-warning"
                        >zatwierdzone?</b-switch
                        >
                      </div>
                      <div v-if="!isLite">
                        <b-switch
                            :value="order.isInvoiceSent"
                            :disabled="isLoading || isChangingTimeModeActive"
                            @input="
														(isInvoiceSent) => changeIsInvoiceSentStatus(order, isInvoiceSent)
													"
                            type="is-info"
                        >fv wysłana?</b-switch
                        >
                      </div>
                      <div v-if="!isLite">
                        <b-switch
                            :value="order.isInvoicePaid"
                            :disabled="isLoading || isChangingTimeModeActive"
                            @input="
														(isInvoicePaid) => changeIsInvoicePaidStatus(order, isInvoicePaid)
													"
                            type="is-danger"
                        >fv zapłacona?</b-switch
                        >
                      </div>
                    </div>
                    <div class="client-order">
                      <p v-if="order.type === 'permanent_point'" class="permanent-point-label">
                        <span class="badge badge-permanent-point">Punkt stały</span>
                        <b>{{ order.clientName }}</b>

                      </p>
                      <a
                          v-else
                          href
                          :disabled="
													!canSeeRouteItemDetails(order)
												"
                          @click.prevent="
													canNonAdminSeeRouteAsAdmin || user.id === getOrderCreatorId(order)
														? $parent.$emit('order-click', order)
														: null
												"
                          class="link"
                      >#{{ order.id }}
                        {{
                          canSeeRouteItemDetails(order)
                              ? order.clientName
                              : '(ukryte)'
                        }}</a
                      >
                      <p class="phone">
                        <i class="mdi">phone</i>
                        {{
                          canSeeRouteItemDetails(order)
                              ? order.phone
                              : '(ukryte)'
                        }}
                      </p>
                      <!-- <p class="address">
                        <i class="location_on"></i>
                        {{
                          canSeeRouteItemDetails(order)
                              ? order.fullAddress
                              : '(ukryte)'
                        }}
                      </p> -->
                      <p class="email" v-if="order.type === 'order'">
                        <i class="mdi">email</i>
                        {{
                          canSeeRouteItemDetails(order)
                              ? (order.email || '(brak)') + ' '
                              : '(ukryte)'
                        }}
                      </p>
                    </div>
                    <div class="point-description" v-if="order.description">
                      <span class="permanent-point-description">{{
                          order.description
                        }}</span>
                    </div>
                    <div
                        class="distance"
                        v-if="
												(!order.lat || !order.lon) &&
												(canSeeRouteItemDetails(order))
											"
                    >
											<span class="no-localization">
												<i class="mdi">close</i> brak lokalizacji!
											</span>
                    </div>
                    <div
                        class="distance"
                        v-if="canSeeRouteItemDetails(order) && hasRouteLocation(order)"
                    >
                      <i class="mdi">{{ getRoutePointIcon(index) }}</i>
                      <template v-if="isRouteStartPoint(index)">Start trasy</template>
                      <template v-if="getRoutePointDistance(index) !== null">
                        {{ getRoutePointDistance(index) }} KM
                      </template>
                      <p v-if="isRouteEndPoint(index)">Koniec trasy</p>
                    </div>
                    <div
                        class="action"
                        v-if="
												!order.emailSent &&
												(order.type === 'order' && (canNonAdminSeeRouteAsAdmin || user.id === getOrderCreatorId(order))) &&
												!canSendAsUser
											"
                    >
                      <button
                          type="button"
                          class="button is-primary"
                          :disabled="!order.email || isLoading || isChangingTimeModeActive"
                          @click="sendEmail(order.id, 'system')"
                      >
                        Wyślij email
                      </button>
                    </div>
                    <div
                        class="action"
                        v-if="
												order.emailSent &&
												(order.type === 'order' && (canNonAdminSeeRouteAsAdmin || user.id === getOrderCreatorId(order))) &&
												!canSendAsUser
											"
                    >
                      <span class="email-sent-label">Email wysłano</span>
                      <span class="email-sent-date">{{
                          formatDate(order.emailSent, 'HH:mm DD/MM/YYYY')
                        }}</span>
                      <button
                          type="button"
                          class="button is-small"
                          :disabled="!order.email || isLoading || isChangingTimeModeActive"
                          @click="sendEmail(order.id, 'system')"
                      >
                        Wyślij ponownie
                      </button>
                    </div>
                    <div
                        class="action"
                        v-if="
												!order.emailSent &&
												(order.type === 'order' && (canNonAdminSeeRouteAsAdmin || user.id === getOrderCreatorId(order))) &&
												canSendAsUser
											"
                    >
                      <b-dropdown
                          position="is-bottom-left"
                          :disabled="!order.email || isLoading || isChangingTimeModeActive"
                      >
                        <button
                            class="button is-primary"
                            slot="trigger"
                            @click.prevent
                            type="button"
                        >
                          <span>Wyślij jako</span>
                          <i class="mdi">arrow_drop_down</i>
                        </button>
                        <b-dropdown-item
                            v-if="
														user.mailerIsEnabled &&
														user.mailerIsActive &&
														(!user.mailerMode || user.mailerMode === 'regular')
													"
                            @click="sendEmail(order.id, 'user')"
                        ><b class="item-email">{{ user.mailerEmail }}</b> (Twój
                          email)</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="
														user.mailerIsEnabled &&
														user.mailerIsActive &&
														user.mailerMode === 'gmail'
													"
                            @click="sendEmail(order.id, 'user')"
                        ><b class="item-email">{{ user.googleEmail }}</b> (Twój
                          email)</b-dropdown-item
                        >
                        <b-dropdown-item
                            @click="sendEmail(order.id, 'system')"
                            v-if="isSystemMailerOptionVisible"
                        ><b class="item-email">{{ systemEmail }}</b> (systemowy)</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <div
                        class="action"
                        v-if="
												order.emailSent &&
												(order.type === 'order' && (canNonAdminSeeRouteAsAdmin || user.id === getOrderCreatorId(order))) &&
												canSendAsUser
											"
                    >
                      <span class="email-sent-label">Email wysłano</span>
                      <span class="email-sent-date">{{
                          formatDate(order.emailSent, 'HH:mm DD/MM/YYYY')
                        }}</span>
                      <b-dropdown
                          position="is-bottom-left"
                          :disabled="!order.email || isLoading || isChangingTimeModeActive"
                      >
                        <button class="button is-small" slot="trigger" @click.prevent>
                          <span>Wyślij ponownie jako</span>
                          <i class="mdi">arrow_drop_down</i>
                        </button>
                        <b-dropdown-item
                            v-if="
														user.mailerIsEnabled &&
														user.mailerIsActive &&
														(!user.mailerMode || user.mailerMode === 'regular')
													"
                            @click="sendEmail(order.id, 'user')"
                        ><b class="item-email">{{ user.mailerEmail }}</b> (Twój
                          email)</b-dropdown-item
                        >
                        <b-dropdown-item
                            v-if="
														user.mailerIsEnabled &&
														user.mailerIsActive &&
														user.mailerMode === 'gmail'
													"
                            @click="sendEmail(order.id, 'user')"
                        ><b class="item-email">{{ user.googleEmail }}</b> (Twój
                          email)</b-dropdown-item
                        >
                        <b-dropdown-item
                            @click="sendEmail(order.id, 'system')"
                            v-if="isSystemMailerOptionVisible"
                        ><b class="item-email">{{ systemEmail }}</b> (systemowy)</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </li>
                </transition-group>
              </draggable>
              <p v-else class="no-orders-info">Brak przypisanych zamówień do tej trasy.</p>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot route-modal-footer">
        <div class="level route-modal-footer__level">
          <div class="level-left route-modal-footer__group route-modal-footer__group--primary">
            <button
                type="submit"
                class="button is-success button--save route-modal-footer__button"
                v-if="isEditModeEnabled"
            >
              <i class="mdi route-modal-footer__icon" aria-hidden="true">save</i>
              <span>Zapisz zmiany</span>
            </button>

            <button
                type="button"
                class="button is-primary button--edit route-modal-footer__button"
                :disabled="!canModifyRoute"
                @click.prevent="isEditModeEnabled = true"
                v-else
            >
              <i class="mdi route-modal-footer__icon" aria-hidden="true">edit</i>
              <span>Edytuj</span>
            </button>

            <button
                type="button"
                class="button is-link is-outlined button--edit-route-planning route-modal-footer__button"
                :disabled="!canModifyRoute"
                @click.prevent="goToEditRouteInPlanning"
                v-if="!isEditModeEnabled"
            >
              <span>Edytuj trasę</span>
            </button>

            <button
                type="button"
                class="button is-white button--cancel route-modal-footer__button"
                @click.prevent="$parent.$emit('close')"
            >
              <span>Zamknij</span>
            </button>
          </div>

          <div class="level-right route-modal-footer__group route-modal-footer__group--danger">
            <button
                type="button"
                class="button is-danger is-outlined button--archive route-modal-footer__button"
                :disabled="!canModifyRoute"
                @click.prevent="archive"
                v-if="currentRoute.status !== 'archived'"
            >
              <span>Archiwizuj</span>
            </button>

            <button
                type="button"
                :disabled="!canModifyRoute"
                class="button is-danger is-small button--delete route-modal-footer__button"
                @click.prevent="showDeleteDialog"
            >
              <span>Usuń</span>
            </button>
          </div>
        </div>
      </footer>
    </div>

    <b-modal :active="isColorPickerActive" has-modal-card @close="isColorPickerActive = false">
      <color-picker
          :preselected="getColorByName(currentRoute.color)"
          @select="currentRoute.color = $event.name"
      />
    </b-modal>
  </form>
